import type { Session } from "../../common/repl-console";
import { isWorking, type Run } from "../../common/run-output";
import type { Scope } from "../../common/variables-panel";

// Blank is not wrong here and there is nothing to ask for: the panel says which of the several nothings this one is.
export function runMessage(run: Run, scope: Scope | null): string {
  if (isWorking(run)) return "Variables are read when the run ends.";
  if (scope) return "The script defined no variables.";
  if (run.state === "stopped") return "The run was stopped before its variables could be read.";
  return "Nothing has run yet.";
}

// The same several nothings, told apart at a prompt: a session that has ended is one whose names went with it.
export function sessionMessage(run: Run, scope: Scope | null, session: Session): string {
  if (isWorking(run)) return "Variables are read when the line returns.";
  if (scope) return "The session has bound no names.";
  if (session.entries.length > 0) return "The interpreter was stopped, and the session's names went with it.";
  return "Nothing has been entered yet.";
}

export type Mode = "script" | "repl";

// A worker that could not be built answers nothing at all, so what is waiting on it is told this instead.
export const COULD_NOT_START = "The interpreter could not be started.";

// Out here because the panel memoises on it: an object written into the element would be a new one on every render.
export const IMPORTED = { label: "Imported", one: "name", many: "names" };

// What a Python prompt says it is waiting for: the start of something, or the rest of what was started.
export const MARKS = { prompt: ">>>", continued: "..." };

// Said of the block that was interrupted, where the panel says the same of the names: one note apiece, not one twice.
export const STOPPED_NOTE = "Stopped, and the session's names went with the interpreter.";
